module.exports = __webpack_public_path__ + "static/media/blackHeartIcon.8e74f65e.svg";